"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FieldContextProvider: function() {
        return FieldContextProvider;
    },
    useFieldContext_unstable: function() {
        return useFieldContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const FieldContext = /*#__PURE__*/ _react.createContext(undefined);
const FieldContextProvider = FieldContext.Provider;
const useFieldContext_unstable = ()=>_react.useContext(FieldContext);
